class CNS {
    constructor() {
        this.$modals = {}
        this.$fns = {}
    }

    $ = function (selector) {
        return document.querySelector(selector)
    }

    $$ = function (selector) {
        return document.querySelectorAll(selector)
    }

    isAndroid = function () {
        return navigator.userAgent.toLowerCase().indexOf('android') > -1
    }

    isIOS = function () {
        return (
            [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
        )
    }

    checkVersion = function () {
        const agent = window.navigator.userAgent
        const start = agent.indexOf('OS ')
        if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
            return window.Number(agent.substr(start + 3, 3).replace('_', '.'))
        }
        return 0
    }

    smoothScroll = function (targetEl, duration) {
        const headerElHeight = document.querySelector('.header').clientHeight
        let target = targetEl[0]
        let targetPosition = target.getBoundingClientRect().top - headerElHeight
        let startPosition = window.pageYOffset
        let startTime = null

        const ease = function (t, b, c, d) {
            t /= d / 2
            if (t < 1) return (c / 2) * t * t + b
            t--
            return (-c / 2) * (t * (t - 2) - 1) + b
        }

        const animation = function (currentTime) {
            if (startTime === null) startTime = currentTime
            const timeElapsed = currentTime - startTime
            const run = ease(timeElapsed, startPosition, targetPosition, duration)
            window.scrollTo(0, run)
            if (timeElapsed < duration) requestAnimationFrame(animation)
        }
        requestAnimationFrame(animation)
    }
}

window.CNS = new CNS()
